export default {
  header: [
    {
      text: 'Home',
      to: '/',
    },
    {
      text: 'Lösungen',
      sections: [
        {
          title: 'Unsere Lösungen',
          items: [
            {
              title: 'Sales Block',
              description: 'Leads generieren & schnellere Abschlüsse',
              to: '#solutions-dash',
            },
            {
              title: 'Office Block',
              description: 'Backoffice automatisieren & Zeit sparen',
              to: '#solutions-dash',
            },
            {
              title: 'Insight Block',
              description: 'Daten verstehen & Chancen nutzen',
              to: '#solutions-dash',
            },
            {
              title: 'Service Block',
              description: 'Kundenservice skalieren & verbessern',
              to: '#solutions-dash',
            },
          ],
        },
      ],
    },
    {
      text: 'Consulting',
      to: '#consulting',
    },
    {
      text: 'Preise',
      to: '/pricing',
    },
    {
      text: 'Ressourcen',
      sections: [
        {
          title: 'Ressourcen',
          items: [
            {
              title: 'FAQ',
              description: 'Häufig gestellte Fragen',
              to: '/faq',
            },
            {
              title: 'Blog & Artikel',
              description: 'Coming Soon!',
              to: '/',
            },
            {
              title: 'Fallstudien',
              description: 'Coming Soon!',
              to: '/',
            },
            {
              title: 'Ressourcen',
              description: 'Coming Soon!',
              to: '/',
            },
          ],
        },
      ],
    },
    {
      text: 'Blcks',
      sections: [
        {
          title: 'Über Blcks',
          items: [
            {
              title: 'Über uns',
              description: 'Unser Team & Vision',
              to: '/about',
            },
            {
              title: 'Karriere',
              description: 'Coming Soon!',
              to: '/',
            },
            {
              title: 'Kontakt',
              description: 'Schreibe uns eine Nachricht!',
              to: '/contact',
            },
          ],
        },
      ],
    },
  ],
};